/*!
 *
 * agent.js
 *
 */
import 'utility';
import initSiteMegaMenu from 'site-mega-menu';
import initSiteMenu from 'site-menu';
function initAgent() {
    setTimeout(() => {
        document.documentElement.style.setProperty('--scroll-behavior', 'smooth');
    }, 100);
    const header = document.querySelector('[data-site-header]');
    if (header) {
        const megaMenu = initSiteMegaMenu(header);
        initSiteMenu(header, megaMenu.closeAll);
    }
    void initSlider();
    void initNewUp();
    void initFaq();
}
async function initSlider() {
    const sliders = document.querySelectorAll('.c-works-slider');
    if (sliders.length === 0)
        return;
    const { default: buildSlider } = await import(
    /* webpackChunkName: "slider" */ 'slider');
    buildSlider(sliders);
}
async function initNewUp() {
    const elements = document.querySelectorAll('[data-new-up]');
    if (elements.length === 0)
        return;
    const { default: buildNewUp } = await import(
    /* webpackChunkName: "new-up" */ 'new-up');
    buildNewUp(elements);
}
async function initFaq() {
    const faq = document.querySelector('.c-faq');
    if (!faq)
        return;
    const { default: Accordion } = await import(
    /* webpackChunkName: "accordion" */ 'accordion');
    Accordion('.c-faq', {
        speed: 500,
        easing: 'easeOutExpo',
    });
}
if (document.readyState !== 'loading') {
    initAgent();
}
else {
    document.addEventListener('DOMContentLoaded', initAgent);
}
